export default __webpack_public_path__ + "static/rsvp-65a7d669e2fb9f177c7d13e91b0224f4.jpg";